export class ShippingOptionStruct {
    constructor({ id, integration_id, label, description, question_ids, conditions, rounding, carriers_ungrouped, enabled, order }, questions) {
        this.id = id || '';
        this.integration_id = integration_id || '';
        this.label = label || '';
        this.description = description || '';
        this.conditions = transformToGroupedConditions(conditions);
        this.condition_count = Array.isArray(conditions) ? conditions.length : 0;
        this.rounding = rounding || 0;
        this.carriers_ungrouped = carriers_ungrouped ?? false;
        this.enabled = enabled ?? true;
        this.order = order || 0;

        // Transform question IDs to include text from the available questions
        // output will be {text, value}
        this.question_ids =  (question_ids || []).map(id => {
            questions = questions || [];
            return questions.find(q => q.value == id || q.value == Number(id)) || { text: id, value: id };
        });
    }
}

export class ShippingOptionCarrierStruct {
    constructor({ id, shipping_option_id, carrier_id, carrier_name, service_id, service_name, exclude, conditions, order }) {
        this.id = id || '';
        this.shipping_option_id = shipping_option_id || '';
        this.carrier_id = carrier_id || 0;
        this.carrier_name = carrier_name || '';
        this.service_id = service_id || 0; // 0 means all services
        this.service_name = service_name || '';
        this.exclude = exclude || false;
        this.conditions = transformToGroupedConditions(conditions);
        this.condition_count = Array.isArray(conditions) ? conditions.length : 0;
        this.order = order || 0;
    }
}

export class ShippingOptionPricingRuleStruct {
    constructor({ id, shipping_option_id, label, type, adjustment_value, percentage_based, minimum_shipping_cost, maximum_shipping_cost, conditions, enabled, order }) {
        this.id = id || '';
        this.shipping_option_id = shipping_option_id || '';
        this.label = label || '';
        this.type = type || 0; //default is markup
        this.adjustment_value = adjustment_value || 0;
        this.percentage_based = percentage_based ?? false;
        this.minimum_shipping_cost = minimum_shipping_cost || null;
        this.maximum_shipping_cost = maximum_shipping_cost || null;
        this.conditions = transformToGroupedConditions(conditions);
        this.condition_count = Array.isArray(conditions) ? conditions.length : 0;
        this.enabled = enabled ?? true;
        this.order = order || 0;
    }
}

export class ShippingOptionConditionStruct {
    constructor({ fieldName, customField, operator, value }) {
        this.fieldName = fieldName || '';
        this.customField = customField || '';
        this.operator = operator || '';
        this.value = value || '';
    }
}

export const DEFAULT_SHIPPING_OPTIONS = [
    {
        label: 'Shipping',
        description: 'Shipping with leading Australian carriers',
        question_ids: [13],
        conditions: [
            [
                {
                    fieldName: 'max-weight',
                    operator: '<=',
                    value: 30
                }
            ]
        ],
    },
    {
        label: 'Tailgate Delivery',
        description: 'Receiver does NOT have a forklift',
        question_ids: [13, 7],
        conditions: [
            [
                {
                    fieldName: 'max-weight',
                    operator: '>=',
                    value: 30
                }
            ],
            [
                {
                    fieldName: 'max-weight',
                    operator: '<=',
                    value: 9999
                }
            ]
        ],
    },
    {
        label: 'Forklift At Delivery Point',
        description: 'Receiver has a forklift to unload items from truck',
        question_ids: [],
        conditions: [
            [
                {
                    fieldName: 'max-weight',
                    operator: '>=',
                    value: 30
                }
            ],
            [
                {
                    fieldName: 'max-weight',
                    operator: '<=',
                    value: 9999
                }
            ]
        ],
    }
];

export const DEFAULT_QUESTIONS = [
        {
            value: 7,
            text: "Hydraulic Lift"
        },
        {
            value: 8,
            text: "Crane Truck"
        },
        {
            value: 13,
            text: "Residential"
        },
        {
            value: 14,
            text: "Authorised To Leave"
        },
        {
            value: 36,
            text: "Hand Unload"
        },
];

function transformToGroupedConditions(conditions = []) {
    if(!Array.isArray(conditions) || conditions.length === 0) {
        return [[new ShippingOptionConditionStruct({})]];
    }

    return conditions.map(group => {
        if (Array.isArray(group)) {
            return group.map(condition => new ShippingOptionConditionStruct(condition));
        }
    });
}